module.exports = __webpack_public_path__ + "04_glasses_brown.19d865ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/son/layer4/04_glasses_brown.png
// module id = b4i9
// module chunks = 0